import { Component, OnInit } from '@angular/core';
import { StockMobileService } from '@services/sysnet/stock-mobile.service';

@Component({
  selector: 'app-stock-mobile-stepper',
  templateUrl: './stock-mobile-stepper.component.html',
  styleUrls: ['./stock-mobile-stepper.component.scss']
})
export class StockMobileStepperComponent implements OnInit {

    private _cachedSteps: number[] = [];

    constructor(public stockMobileService: StockMobileService) {
    }

    public ngOnInit(): void {
        this.updateSteps();
    }

    public get totalSteps(): number {
        return this.stockMobileService.totalSteps;
    }

    public get currentStep(): number {
        return this.stockMobileService.currentStep;
    }

    public get showStepper(): boolean {
        return this.stockMobileService.showStepper;
    }

    public get steps(): number[] {
        // Regenerate steps whenever totalSteps changes
        if (this._cachedSteps.length !== this.totalSteps) {
            this._cachedSteps = Array.from({ length: this.totalSteps }, (_, i) => i);
        }
        return this._cachedSteps;
    }

    private updateSteps(): void {
        this._cachedSteps = Array.from({ length: this.totalSteps }, (_, i) => i);
    }
}
